import axios from "axios"
import { constants } from "@/config/constants"

const syncNotifications = (context) => {
  let lists = [
    {
      key: "new_notifications",
      module: "notifications",
      query: "query_status=new"
    },
    {
      key: "recent_notifications",
      module: "notifications",
      query: "mode=recent-only&query_statuses=new,completed&rows_per_page=5&sort_by=recent&sort_order=desc"
    },
  ]

  axios
    .post(constants.API_URL + "open/request/ddlists", lists)
    .then((res) => {
      let new_notifications = res.data.new_notifications
      let recent_notifications = res.data.recent_notifications

      context.commit("NEW_NOTIFICATIONS", new_notifications)
      context.commit("RECENT_NOTIFICATIONS", recent_notifications)
    })
}

const setActiveNotifications = (context, data) => {
  context.commit("ACTIVE_NOTIFICATIONS", data)
}

const setRecentNotifications = (context, data) => {
  context.commit("RECENT_NOTIFICATIONS", data)
}

const setShowNotificationBar = (context, data) => {
  context.commit("SHOW_NOTIFICATION_BAR", data)
}

const showPopupNotifications = (context, vm) => {
  var notifications = context.rootState.notification.activeNotifications
  notifications.forEach((item, index) => {
    if(item.type == "popup") {
      vm.$swal({
        title: item.header,
        html: item.body,
        icon: "info"
      })
    }
  })
}

export default {
  syncNotifications,
  setActiveNotifications,
  setRecentNotifications,
  setShowNotificationBar,
  showPopupNotifications,
}